import React from "react"
import { Cell } from "fixed-data-table-2"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { useViewportSize } from "@mantine/hooks"

import { decodeStyles } from "app/static/frontend/imports/styleHelperFunctions"
import sheetVars from "app/static/stylus/sheets-variables.json"
import InputCell from "app/static/frontend/sheets/components/cells/InputCell"
import ErrorCell from "app/static/frontend/sheets/components/cells/ErrorCell"
import StatCellBar from "app/static/frontend/sheets/components/cells/StatCellBar"
import { statCellConnection } from "app/static/frontend/sheets/selectors/column-selectors"
import { formatNumber } from "app/static/frontend/sheets/helper-functions"
import { statCellError } from "app/static/frontend/sheets/components/helpTexts"
import { formatNumberWithCurrencyPrecision } from "shared/imports/sharedHelperFunctions"
import { hasAnyPermission } from "shared/imports/permissionFunctions"

const sheetsVariables = decodeStyles(sheetVars)

export const StatCell = ({
    barWidth,
    children,
    columnId,
    columnIndex,
    cellIsEditable,
    derived,
    editing,
    isEditable,
    rowId,
    sheetId,
    shouldDisplayAsCurrency,
    shouldRoundCellValue,
    sheetOrganizationId,
    ...props
}) => {
    /**
     * REFACTOR: optimize this by moving this to a higher component.
     * This is pretty inefficient since it gets triggered on viewport resize for every cell on a sheet.
     *
     * There is an isMobile property in ResponsiveSheet.jsx, but it doesn't appear that's actually working.
     * So we'd probably have to refactor that to use Mantine's useViewPortSize hook, then pass that down as a prop.
     */
    const { width: vwidth } = useViewportSize()

    if (editing && isEditable && cellIsEditable) {
        return (
            <InputCell
                type="number"
                columnId={columnId}
                isResourceTable={props.isResourceTable}
                rowId={rowId}
                sheetId={sheetId}
                width={props.width}
                field={props.field}
            >
                {children}
            </InputCell>
        )
    }
    if (children === null || children === undefined || children === "") {
        return <Cell {...props}>{children}</Cell>
    }

    // if there were errors computing the cell value, display to user reason
    if (Number.isNaN(children) || children === Infinity) {
        return (
            <Cell {...props} style={statCellError.dividyByZero.cellStyles}>
                <ErrorCell tooltipLabel={statCellError.dividyByZero.tooltipText} iconClassName="cell-error-centered" />
            </Cell>
        )
    }

    const isForcedCurrency = hasAnyPermission([DjangIO.app.models.PermissionType.qpac_v1]) && shouldDisplayAsCurrency

    // do not show the bar in a stat cell if it's mobile and the sheet is owned by Citi OR a QPAC currency column
    const shouldShowStatCellBar = !(
        (vwidth <= sheetsVariables.MAX_MOBILE_WIDTH && sheetOrganizationId === 3161) ||
        isForcedCurrency
    )

    return (
        <div className="stat-cell">
            <Cell {...props}>
                <div
                    style={isForcedCurrency ? { "text-align": "right" } : {}}
                    className={isForcedCurrency ? "" : "stat-cell-text"}
                    data-cy={`stat-cell-text-${rowId}`}
                >
                    {isForcedCurrency
                        ? formatNumberWithCurrencyPrecision(Number(children))
                        : formatNumber(Number(children), shouldRoundCellValue)}
                </div>
                {shouldShowStatCellBar && <StatCellBar barWidth={barWidth} isCalculated={derived} />}
            </Cell>
        </div>
    )
}

export default connect((state, props) => statCellConnection(state, props), {})(StatCell)

StatCell.propTypes = {
    editing: PropTypes.bool,
    isEditable: PropTypes.bool,
    shouldRoundCellValue: PropTypes.bool.isRequired,
    isRenderingPercent: PropTypes.bool,
    cellIsEditable: PropTypes.bool,
}

StatCell.defaultProps = {
    // keep for backwards compatibility. Eventually should be switched
    // when redoing Sheet.jsx and columnIsEditable
    isEditable: true,
    editing: false,
    isRenderingPercent: false,
    cellIsEditable: true,
}
